import Slider from "react-slick";
import { Container, Row, Col } from "react-bootstrap";
import './carousel.css'

import rxnt from "../../images/carousel/rxnt.svg";
import frank from "../../images/carousel/frank.svg";
import thomson from "../../images/carousel/thomson.svg";
import anatomie from "../../images/carousel/anatomie.svg";
import svhs from "../../images/carousel/svhs.svg";
import asn from "../../images/carousel/asn.svg";
import openn from "../../images/carousel/openn.svg";
import hopscotch from "../../images/carousel/hopscotch.svg";
import hatem from "../../images/carousel/hatem.svg";
import interplai from "../../images/carousel/interplai.svg";
import tds from "../../images/carousel/tds-logo.svg";
import myOutcomes from "../../images/carousel/my-outcomes.svg";
import mobi from "../../images/carousel/mobi.svg";
import westBoca from "../../images/carousel/west-boca.svg";
import vacSewCenter from "../../images/carousel/vacsew-center.svg";
import tynax from "../../images/carousel/tynax.svg";

const BrandsCarousel = () => {
    const brandsCarouselSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className="brands-carousel-wrapper py-4">
            <Container fluid>
                <Row>
                    <Col xs='12'>
                        <div className="text-center mb-4">
                            <h2 className="ft-wt-700 text-uppercase text-primary">Businesses We Have Scaled</h2>
                        </div>
                    </Col>
                    <Col xs="12">
                        <Slider {...brandsCarouselSettings} className="brands-carousel">
                            <div>
                                <img src={rxnt} alt="rxnt" loading="lazy" />
                            </div>
                            <div>
                                <img src={frank} alt="frank" loading="lazy" />
                            </div>
                            <div>
                                <img src={thomson} alt="thomson" loading="lazy" />
                            </div>
                            <div>
                                <img src={anatomie} alt="anatomie" loading="lazy" />
                            </div>
                            <div>
                                <img src={svhs} alt="svhs" loading="lazy" />
                            </div>
                            <div>
                                <img src={asn} alt="asn" loading="lazy" />
                            </div>

                            <div>
                                <img src={openn} alt="openn" loading="lazy" />
                            </div>
                            <div>
                                <img src={hopscotch} alt="hopscotch" loading="lazy" />
                            </div>
                            <div>
                                <img src={hatem} alt="hatem" loading="lazy" />
                            </div>
                            <div>
                                <img src={interplai} alt="interplai" loading="lazy" />
                            </div>
                            <div>
                                <img src={tds} alt="svhs" loading="lazy" />
                            </div>
                            <div>
                                <img src={myOutcomes} alt="myOutcomes" loading="lazy" />
                            </div>
                            <div>
                                <img src={mobi} alt="mobi" loading="lazy" />
                            </div>
                            <div>
                                <img src={westBoca} alt="westBoca" loading="lazy" />
                            </div>
                            <div>
                                <img src={vacSewCenter} alt="vacSewCenter" loading="lazy" />
                            </div>
                            <div>
                                <img src={tynax} alt="tynax" loading="lazy" />
                            </div>
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default BrandsCarousel;
